import { Button, SegmentedControl, Text } from "@mantine/core"
import React from "react"
import { useTranslation } from "react-i18next"
import { OrderApi } from "../../apis"
import HttpHandler from "../../utils/http-handler"
import { message } from "../../utils/message"
import { OrderActionCard } from "../order/order-action-card"
import { useSalesActions } from "../order/order-actions"
import { ReasonTooltip } from "../ui"

type Props = {
  action?: any
  setActions?: any
  constant?: "confirm" | "reject" | string
  reload?: any
}

/**
 * Батлах / Татгалзах (Ord_SalesModals 2.4.2). Each decision needs its own permission
 * (order/respond.ts: approve=ORD_PO_ACCEPT, decline=ORD_PO_DECLINE).
 */
export function SupplierSalesDynamicConfirmForm({ action, setActions, constant, reload }: Props) {
  const { t } = useTranslation(["supplierSales", "common"])
  const [loading, setLoading] = React.useState<boolean>(false)
  const [mode, setMode] = React.useState<"confirm" | "reject">(constant === "reject" ? "reject" : "confirm")
  const { permissionState } = useSalesActions()
  const approve = mode === "confirm"
  const perm = permissionState(approve ? "approve" : "decline")

  const onSubmit = async () => {
    setLoading(true)
    try {
      await OrderApi.respond(action?.id, { approve })
      setActions([])
      message.success(t(approve ? "supplierSales:sales.confirmApprovedSuccess" : "supplierSales:sales.confirmRejectedSuccess"))
      reload?.()
    } catch (err) {
      message.error((err as HttpHandler)?.message!)
    } finally {
      setLoading(false)
    }
  }

  const code = action?.salesCode || action?.purchaseCode || "-"

  return (
    <OrderActionCard
      title={t("supplierSales:sales.modals.respond.title")}
      onClose={() => setActions([])}
      loading={loading}
      footer={
        <>
          <Button variant="default" onClick={() => setActions([])}>{t("common:actions.dismiss")}</Button>
          <ReasonTooltip reason={perm.reason}>
            <Button color={approve ? undefined : "gray"} variant={approve ? "filled" : "default"} onClick={onSubmit}>
              {t(approve ? "supplierSales:sales.approve" : "supplierSales:sales.decline")}
            </Button>
          </ReasonTooltip>
        </>
      }
    >
      <SegmentedControl
        value={mode}
        onChange={(v) => setMode(v as "confirm" | "reject")}
        data={[
          { value: "confirm", label: t("supplierSales:sales.approve") },
          { value: "reject", label: t("supplierSales:sales.decline") },
        ]}
      />
      <Text fz={14}>
        {t(approve ? "supplierSales:sales.modals.respond.approveBody" : "supplierSales:sales.modals.respond.declineBody", { code })}
      </Text>
    </OrderActionCard>
  )
}
